// extracted by mini-css-extract-plugin
export default {"scientificName":"scientificName__SpeciesNameParts__k+7hh","reference":"reference__SpeciesNameParts__k+7hh"};